/**
 * @fileoverview Transformación del contenido del Centro de Ayuda: respuestas en markdown
 * sanitizadas y resultados de búsqueda filtrados por los productos del usuario.
 * @module utils/help-center-content
 */

import DOMPurify from 'dompurify'
import { markdown } from 'markdown'

/**
 * Convierte markdown a HTML y lo sanitiza.
 * @param {string} text - Respuesta en markdown
 * @returns {string} HTML sanitizado
 */
export function renderMarkdown (text) {
  return DOMPurify.sanitize(markdown.toHTML(text))
}

/**
 * Renderiza la respuesta de una pregunta y marca sus links para registrar el clic.
 * Los atributos se agregan después de sanitizar porque DOMPurify elimina `target`.
 * @param {string} text - Respuesta en markdown
 * @returns {string} HTML sanitizado con `target="_target" ref="links"` en cada <a
 */
export function renderAnswer (text) {
  return renderMarkdown(text).replace(/<a/gi, '<a target="_target" ref="links"')
}

/**
 * Arma los resultados de una búsqueda: una fila por cada producto del usuario al que pertenece la pregunta.
 * @param {Array<Object>} questions - Preguntas devueltas por la búsqueda ({id, order, question, response, topicId, plans})
 * @param {Array<string>} productCodes - Códigos de los productos del usuario
 * @returns {Array<Object>} Resultados con la respuesta sanitizada y el producto (plan) al que pertenecen
 * @throws {TypeError} Si una pregunta no trae `plans` (el backend devuelve el catálogo cuando la búsqueda va vacía)
 */
export function buildSearchResults (questions, productCodes) {
  const results = []
  questions.forEach(question => {
    question.plans.forEach(plan => {
      if (!productCodes.includes(plan)) return
      results.push({
        id: question.id,
        order: question.order,
        question: question.question,
        response: renderMarkdown(question.response),
        topicId: question.topicId,
        plan
      })
    })
  })
  return results
}



// WEBPACK FOOTER //
// ./src/utils/help-center-content.js